import { useAllQueryParams } from "@/shared/lib/hooks";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/ru";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

type RangePickerValue = [Dayjs, Dayjs] | null;
const { RangePicker } = DatePicker;

const RangeDatePicker = ({
  filterable = true,
  placeholder = ["Boshlanishi", "Tugashi"],
  onchange,
  clearable = true,
  defaultValues,
  disabledDate
}: {
  filterable?: boolean;
  placeholder?: [string, string];
  onchange?: (value: RangePickerValue) => void;
  clearable?: boolean;
  defaultValues?: RangePickerValue;
  disabledDate?: boolean;
}) => {
  const [date, setDate] = useState<RangePickerValue>(
    defaultValues ? defaultValues : null
  );
  const [_, setSearchParams] = useSearchParams();
  const allParams = useAllQueryParams();

  const onDateChange = (value: RangePickerValue) => {
    setDate(value);
    if (filterable) {
      if (value === null) {
        delete allParams?.date_from;
        delete allParams?.date_to;
        setSearchParams({
          ...allParams,
        });
      }
      if (value && dayjs(value?.[0]).isValid() && dayjs(value?.[1]).isValid()) {
        setSearchParams({
          ...allParams,
          date_from: String(dayjs(value[0]).startOf("day").toISOString()),
          date_to: String(dayjs(value[1]).endOf("day").toISOString()),
        });
      }
    }
  };

  useEffect(() => {
    if (allParams.date_from && allParams.date_to) {
      setDate([dayjs(allParams.date_from), dayjs(allParams.date_to)]);
    } else if (defaultValues?.[0] && defaultValues?.[1]) {
      setDate(defaultValues);
      setSearchParams({
        ...allParams,
        date_from: String(dayjs(defaultValues[0]).startOf("day").toISOString()),
        date_to: String(dayjs(defaultValues[1]).endOf("day").toISOString()),
      });
    }
  }, []);

  const { t } = useTranslation();

  return (
    <RangePicker
      className="w-full"
      size="large"
      value={date}
      onChange={(val) => {
        onDateChange(val as RangePickerValue);
        onchange?.(val as RangePickerValue);
      }}
      allowClear={clearable}
      disabledDate={(current) => {
        return disabledDate ? (current && current > dayjs().endOf("day")) : false
      }}
      placeholder={[t(placeholder[0]), t(placeholder[1])]}
      inputReadOnly
    />
  );
};

export default RangeDatePicker;